jQuery.fn.tooltips = function (options) {

	if (this.length === 0) { return; }

	var settings = jQuery.extend({
		title: null,
		xOffset: 10,
		yOffset: 20
	}, options);

	$(this).each(function () {
		var el      = $(this).data('title', $(this).attr('title')).removeAttr('title').addClass('title'),
		    tooltip = $('<div class="tooltip"><p>' + el.data('title') + '</p></div>').hide().appendTo($('body'));

		function update(e) {
			var offset = 0;

			if ((e.pageX + settings.yOffset + tooltip.outerWidth() + 30) >= $(window).width()) {
				offset = tooltip.outerWidth() + 30;
			}

			tooltip.css({
				top: (e.pageY - settings.xOffset) + 'px',
				left: (e.pageX + settings.yOffset - offset) + 'px'
			});
		}

		el.on('mouseenter', function (e) {
			$(this).data('timeout', setTimeout(function () {
				tooltip.fadeIn(100);
			}, 300));

			update(e);
		}).on('mouseleave', function () {
			clearTimeout($(this).data('timeout'));
			tooltip.fadeOut(100);
		}).on('mousemove', function (e) {
			update(e);
		});
	});

	return this;
};
